// extracted by mini-css-extract-plugin
export default {"closeIcon":"CloseIcon_closeIcon__PVmMe"};